/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {colors} from '../../../constants'
import {keyframes} from '@chakra-ui/react'

const navLinkAnimation = keyframes`
  0% {
    transform: translateX(-1rem);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
}`

export default {
    baseStyle: {
        linkItem: {
            fontSize: '16px',
            fontFamily: `"Raleway", sans-serif`,
            lineHeight: '29px',
            marginBottom: '1px',
            fontWeight: '400',
            display: 'flex',
            color: 'black',
            transform: 'translateX(-1rem)',
            opacity: '0',
            transition: 'all 0.3s ease-in-out',
            paddingRight: '12px',
            outline: '0',
            animation: `${navLinkAnimation} 0.3s ease-in-out calc((var(--index) + 1) * 100ms) forwards`
        },
        linkItemText: {
            whiteSpace: 'normal',
            display: 'flex',
            _hover: {
                svg: {
                    opacity: '1'
                },
                textDecoration: 'underline',
                fontWeight: '500'
            }
        },
        activeState: {
            textDecoration: 'underline',
            fontWeight: '500'
        },
        listMenuColumn: {
            borderRight: `1px solid ${colors.platCol}`,
            marginTop: '14px',
            _last: {
                borderRight: '0'
            }
        }
    }
}
